import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/useAuthStore'
import { Spinner } from '@/components/ui'
import { ROUTES } from '@/constants/routes'
import styles from './AdminRoute.module.css'

export function AdminRoute() {
    const { isLogged, isLoading, getUser } = useAuthStore()
    const user = getUser()

    if (isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <Spinner size="lg" />
            </div>
        )
    }

    if (!isLogged) {
        return <Navigate to={ROUTES.login} replace />
    }

    if (!user?.is_staff) {
        return <Navigate to={ROUTES.home} replace />
    }

    return <Outlet />
}
